<template>
  <div class="container">
    <div class="columns box-title is-12">
      <div class="column is-6">
        <h4 class="has-text-left">
          <i class="fal fa-store"></i>
          {{ $t("advanceCodWithdraw.title") }}
          <span class="countTotal">({{ count }})</span>
        </h4>
      </div>
      <div class="column is-6" v-if="$can(['SuperAdmin','marketing','manager'])">
        <button class="btn-add" @click="openAdd">{{ $t("advanceCodWithdraw.add_shop") }}</button>
      </div>
    </div>

    <div class="box">
      <div class="columns">
        <div class="column is-3">
          <label class="label">{{ $t("advanceCodWithdraw.search") }}:</label>
          <input
            class="input"
            type="text"
            v-model="searchItem"
            @keyup.enter="filterBySearch"
          />
        </div>
        <div class="column is-3">
          <label class="label">{{ $t("advanceCodWithdraw.shop_status") }}:</label>
          <div class="select">
            <select class="input" v-model="shop_status" @change="fetchData">
              <option value="">{{ $t("common.all") }}</option>
              <option value="open">{{ $t("advanceCodWithdraw.status_open") }}</option>
              <option value="close">{{ $t("advanceCodWithdraw.status_close") }}</option>
            </select>
          </div>
        </div>
        <div class="column is-2">
          <div class="control filter-btn-wrap">
            <vs-button circle icon flat @click="filterBySearch">
              <i class="fal fa-search"></i>
            </vs-button>
          </div>
        </div>
      </div>
    </div>

    <div class="center fit-width">
      <vs-table ref="table">
        <template #thead>
          <vs-tr>
            <vs-th>{{ $t("advanceCodWithdraw.no") }}</vs-th>
            <vs-th>{{ $t("advanceCodWithdraw.shop_name") }}</vs-th>
            <vs-th>{{ $t("advanceCodWithdraw.tel") }}</vs-th>
            <vs-th>{{ $t("advanceCodWithdraw.created_date") }}</vs-th>
            <vs-th>{{ $t("advanceCodWithdraw.status") }}</vs-th>
            <vs-th>{{ $t("advanceCodWithdraw.withdraw_percent") }}</vs-th>
            <vs-th>{{ $t("advanceCodWithdraw.fee") }}</vs-th>
            <vs-th v-if="$can(['SuperAdmin','marketing','manager'])"></vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
            v-for="(shop, index) in $vs.getPage(shops, page, max)"
            :key="shop.id"
            :data="shop"
          >
            <vs-td>{{ (pagination.current_page - 1) * limit_page + index + 1 }}</vs-td>
            <vs-td>{{ shop.name }}</vs-td>
            <vs-td>{{ shop.customer_tel }}</vs-td>
            <vs-td>{{ moment(shop.created_at).format('DD/MM/YYYY H:mm') }}</vs-td>
            <vs-td :style="{ color: shop.is_active ? '#22a06b' : '#e15454' }">
              {{ shop.is_active ? $t("advanceCodWithdraw.open") : $t("advanceCodWithdraw.close") }}
            </vs-td>
            <vs-td>{{ shop.withdraw_percent }}%</vs-td>
            <vs-td>{{ shop.fee_percent }}%</vs-td>
            <vs-td style="text-align: right; width: 80px" v-if="$can(['SuperAdmin','marketing','manager'])">
              <vs-button circle icon flat @click="openEdit(shop)">
                <i class="fad fa-pencil"></i>
              </vs-button>
            </vs-td>
          </vs-tr>
        </template>
        <template #footer>
          <CodPagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="offset" @paginate="fetchData" />
          <Loading v-if="isLoading" />
        </template>
      </vs-table>
    </div>

    <ModalAdd>
      <template v-slot="{ close }">
        <AddEditDialog @close="close" @success="fetchData" />
      </template>
    </ModalAdd>
    <ModalEdit>
      <template v-slot="{ close }">
        <AddEditDialog :item="item" @close="close" @success="fetchData" />
      </template>
    </ModalEdit>
  </div>
</template>

<script>
import Loading from '@/views/Loading';
import CodPagination from '@/components/CodPagination';
import AddEditDialog from '@/views/Corporate/AdvanceCodWithdraw/Dialog/AddEdit';
import { fetchAdvanceCodStores } from '@/views/Corporate/AdvanceCodWithdraw/api';

export default {
  components: { Loading, CodPagination, AddEditDialog },
  data: () => ({
    page: 1,
    max: 10,
    isLoading: true,
    shop_status: '',
    shops: [],
    item: {},
    searchItem: '',
    count: 0,
    offset: 10,
    limit_page: 10,
    pagination: { current_page: 1, last_page: 1 },
  }),
  watch: {
    searchItem(v) { if (v === '') this.fetchData(); },
  },
  methods: {
    fetchData(options = {}) {
      this.isLoading = true;
      const params = {
        page: options.current_page ?? this.pagination.current_page,
        per_page: options.per_page ?? this.limit_page,
        search: this.searchItem,
      };
      if (this.shop_status === 'open')  params.is_active = 'true';
      if (this.shop_status === 'close') params.is_active = 'false';

      fetchAdvanceCodStores(this.$http, params).then((res) => {
        this.shops = res.data.data;
        this.count = res.data.total;
        this.pagination = res.data;
        this.isLoading = false;
      }).catch(() => { this.isLoading = false; });
    },
    openAdd() {
      this.$store.commit('modalAdd_State', true);
    },
    openEdit(shop) {
      this.item = JSON.parse(JSON.stringify(shop));
      this.$store.commit('modalEdit_State', true);
    },
    filterBySearch() {
      this.pagination.current_page = 1;
      this.fetchData();
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style lang="scss" scoped>
.container { margin-top: 40px; }

.box-title h4 {
  font-size: 18px;
  color: $primary-color;
  font-weight: 500;
  i { margin-right: 6px; }
  .countTotal { color: $primary-color; margin-left: 4px; }
}

.btn-add {
  float: right;
  background: #195BFF;
  color: #fff;
  border: none;
  border-radius: 8px;
  height: 38px;
  padding: 0 18px;
  font-size: 14px;
  font-family: $font;
  cursor: pointer;
  &:hover { background: #1450e6; }
}

.filter-btn-wrap {
  display: flex;
  align-items: flex-end;
  height: 100%;
}

.fit-width { white-space: nowrap; }

::v-deep .vs-table__td,
::v-deep .vs-table__th {
  vertical-align: middle !important;
  white-space: nowrap !important;
  width: 1px !important;
}
</style>
